export const environment = {
  production: false,
  googleAuthUrl:
    'https://hml.projeto.saudeconectada.cists.com.br/backend/oauth2/authorization/google',
  azureAuthUrl:
    'https://hml.projeto.saudeconectada.cists.com.br/backend/oauth2/authorization/azure',
  apiUrl: 'https://hml.projeto.saudeconectada.cists.com.br/backend/api',
  serverUrl: 'https://hml.projeto.saudeconectada.cists.com.br/backend'
};
